import { lazy, Suspense } from 'react';
import { StandardPolicyGuard } from 'src/auth/guard';
import { LoadingScreen } from 'src/components/loading-screen';
import AppLayout from 'src/layouts/app';

const FulfillmentsPage = lazy(() => import('src/pages/fulfillments/fulfillments'));

export const fulfillmentsRoutes = [
  {
    path: 'fulfillments',
    element: (
      <StandardPolicyGuard
        fallback={
          <AppLayout>
            <LoadingScreen />
          </AppLayout>
        }
      >
        <AppLayout>
          <Suspense fallback={<LoadingScreen />}>
            <FulfillmentsPage />
          </Suspense>
        </AppLayout>
      </StandardPolicyGuard>
    ),
  },
];
